{
  "id": "nbs",
  "nome": "NFSe NBS",
  "fonte": "NFSe Nacional — Anexo B NBS2 Lista Serviço Nacional",
  "endpoints": [
    "https://www.gov.br/nfse/pt-br/biblioteca/documentacao-tecnica/documentacao-atual/anexo_b-nbs2-lista_servico_nacional-snnfse.xlsx/@@download/file/ANEXO_B-NBS2-LISTA_SERVICO_NACIONAL-SNNFSe.xlsx"
  ],
  "capturadoEm": "2026-08-05",
  "atualizadoEm": "2026-08-05T06:01:45.234Z",
  "contagens": {
    "nbs": 917
  },
  "alteracoes": {
    "adicionados": 0,
    "removidos": 0,
    "alterados": 0,
    "comparadoCom": "2026-08-04"
  },
  "verificacao": {
    "agendamento": "diario",
    "workflow": "data-refresh-bot.yml",
    "ultimaExecucao": "2026-08-05T06:01:45.234Z"
  },
  "documentacao": "docs/OFFICIAL-SOURCES.md#nbs"
}
